import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="mt-auto">
      <div className="max-w-6xl mx-auto px-4 py-6">
        <div className="flex justify-center items-center gap-4 text-sm text-gray-600">
          <a 
            href="https://elev8tek.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-purple-600 transition-colors"
          >
            © 2025 ELEV8TEK
          </a>
          <span className="text-gray-400">|</span>
          <Link 
            to="/terms" 
            className="hover:text-purple-600 transition-colors"
          >
            Terms & Conditions
          </Link>
          <span className="text-gray-400">|</span>
          <Link 
            to="/privacy" 
            className="hover:text-purple-600 transition-colors"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
